import React from "react";
import PropTypes from 'prop-types';

import './sass/carousel.css';

import {Image} from '../Image'

export const Carousel =  ({config, data}) => {

    const id = config.id;
    const carouselWidth  = config.width  ? config.width  : "600px";
    const carouselHeight = config.height ? config.height : "400px";
    const ctStyleSize = { 
        width: "100%",
        height: "100%"
    };
    const styleSize = { 
        minWidth: carouselWidth, minHeight: carouselHeight , 
        maxWidth: carouselWidth, maxHeight: carouselHeight
    };
    const textPrev = "Previous"
    const textNext = "Next";

    const showIndicator = config && config.indicator === false ? false : true ;
    const classIndicatorBtn = config?.classIndicatorBtn ? config.classIndicatorBtn : "";
    const classIndicators = config?.classIndicators ? config.classIndicators : "";
    const classindicatorDown = classIndicators.indexOf("carousel-indicators-down") >= 0 ? "carousel-fix-down" : "";
    const showControl = config && config.control === false ? false : true ;

    return (
        <>
            <div id={id} className={`carousel carousel-dark slide ${classIndicators} ${classindicatorDown}` }
                 data-bs-ride="carousel" 
                style={ctStyleSize} >
                <div className="carousel-inner" >
                    <CarouselItems data={data} styleImg={styleSize} />
                </div>
                { showControl ? 
                (<button className="carousel-control-prev" type="button" data-bs-target={`#${id}`} data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">{textPrev}</span>
                </button>)
                : <></>
                } 
                { showControl ? 
                (
                <button className="carousel-control-next" type="button" data-bs-target={`#${id}`} data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">{textNext}</span>
                </button>)
                : <></>
                }                
                {showIndicator ? <div className={`${classIndicators} carousel-indicators`}>
                    <Indicator idComponent={id} data={data} show={showIndicator} classIndicator={classIndicatorBtn}/>
                </div> : <></>}
            </div>

        </>
    );
}


Carousel.propTypes = {
    config : PropTypes.shape(
        {
            id : PropTypes.string.isRequired,
            height : PropTypes.string,
            width : PropTypes.string,
            indicator : PropTypes.bool,
            classIndicatorBtn : PropTypes.string,
            classIndicators : PropTypes.string,
            control : PropTypes.bool

        }).isRequired,
    data : PropTypes.arrayOf(
        PropTypes.shape({
            img : PropTypes.string,
            text : PropTypes.string,
            tittle : PropTypes.string,
            ref : PropTypes.string,
            btnTittle : PropTypes.string,
            actionBanner : PropTypes.func, // Si tiene ref no funciona
            content : PropTypes.element
        })).isRequired
} 

const Indicator = ({idComponent,data,show, classIndicator}) =>{
    if(show !== false && data && data.length && data.length > 0){
        return (
            <>
                {
                    data.map((el) => 
                            <button id={`indicator${data.indexOf(el)}`} key={`indicator${data.indexOf(el)}`} 
                                type="button" data-bs-target={`#${idComponent}`} data-bs-slide-to={data.indexOf(el)} 
                                className={ `${classIndicator} ${(data.indexOf(el) === 0 ? "active" : "")}`} 
                                aria-current={data.indexOf(el) === 0 ? "true" : ""} 
                                aria-label={`Slide ${data.indexOf(el)}`}>
                            </button>
                        
                    )
                }


            </>
        );
    }

    return (<></>);
};

const CarouselItems = ({data,styleImg}) => { 
    const lbBtnShowMore = "Show More";
    const lblNodata = 'UPS! No data to show';
    const path = "";

    if(data === undefined || data === null || (data && data.length === 0)){
        return (
        <div className="carousel-item active">
            <div className="bg-image" style={styleImg}>
                <div className="carousel-caption">
                    <h1>{lblNodata}</h1>
                </div>
            </div>
        </div>);
    }

    const result = (
        <>
            {
                data.map(el =>  {
                    const noData = el && (el.img || el.tittle || el.text || el.ref || el.content);
                    const active = data.indexOf(el) === 0 ? "active" : "";
                    const tittle = el?.tittle ? <h1>{el.tittle}</h1> : <></>;
                    const text = el?.text ? <p>{el.text}</p> : <></>;
                    const content = el?.content ? el.content : <></>;
                    const button =  el?.ref ? 
                    <p>
                        <a className="btn btn-lg btn-primary" 
                            href={el.ref}>{el.btnTittle ? el.btnTittle : lbBtnShowMore}
                        </a>
                    </p> 
                    : <></>;
                    const action = el?.actionBanner && !el.ref ? el.actionBanner : function(){};
                    const actionClass = el?.actionBanner && !el.ref ? "linkAction " : "";
                    const imgEl = el?.img ? <Image url={path + el.img} title={el.tittle ? el.tittle : ""} width="100%" height="100%" /> : <></>;
                    // rome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
                    return  (<div id={`cr-itm-${data.indexOf(el)}`} key={`cr-itm-${data.indexOf(el)}`} 
                        className={`carousel-item ${actionClass}${active}`} onClick={action}>
                        <div className="bg-image" style={styleImg}>
                            {imgEl}
                            <div className="carousel-caption">
                                {tittle}
                                {text}
                                {button}
                                {content}
                                {noData ? <></> : <h1>{lblNodata}</h1>}
                            </div>
                        </div>
                    </div>);
                })
            }                        
        </>
    );

    return result;
    
};